import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
interface ScrollCTAProps {
  label?: string;
  subtext?: string;
}
const scrollToCheckout = () => {
  document.getElementById('checkout')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function ScrollCTA({
  label = 'GET INSTANT ACCESS — $6.36',
  subtext = 'One-time payment. Instant digital download. 60-day guarantee.'
}: ScrollCTAProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <motion.div ref={ref} className="w-full bg-dark-card border-y border-orange-accent/15 py-8" initial={{
    opacity: 0,
    y: 10
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 10
  }} transition={{
    duration: 0.5
  }} data-id="element-250">
      <div className="max-w-3xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-251">
        <p className="font-inter text-concrete text-sm text-center sm:text-left leading-relaxed" data-id="element-252">
          {subtext}
        </p>

        <motion.button onClick={scrollToCheckout} className="group relative flex-shrink-0 inline-flex items-center gap-3 px-7 py-3.5 bg-orange-accent text-white font-inter font-bold text-sm uppercase tracking-widest rounded-sm overflow-hidden transition-all duration-300 hover:bg-orange-accent/90 hover:scale-[1.02] active:scale-[0.98]" whileHover={{
        boxShadow: '0 0 24px rgba(224, 123, 57, 0.45)'
      }} data-id="element-253">
          <span data-id="element-254">{label}</span>
          <ArrowDownIcon className="w-4 h-4 transition-transform group-hover:translate-y-0.5" data-id="element-255" />

          {/* Subtle pulse */}
          <motion.span className="absolute inset-0 border border-orange-accent rounded-sm" animate={{
          scale: [1, 1.04, 1],
          opacity: [0.4, 0, 0.4]
        }} transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-256" />
        </motion.button>
      </div>
    </motion.div>;
}